const IndustriesRoutes = {
  getAllIndustries: "/industry/industryGetAll",
  createIndustry: "/industry/industryCreate",
  updateIndustry: "/industry/industryUpdate",
  deleteIndustry: "/industry/industryDelete"
}

export default IndustriesRoutes;